import starImg from '../../components/atomic/icons/star/star.png';
import './LevelCard.css';

export type LevelCardProps = {
  /** Screen Y of the card (Figma l_* top). */
  top: number;
  title: string;
  description: string;
  achieved?: boolean;
  isCurrent?: boolean;
};

/** Title SVG tight crop (485×56) → relative to plate. */
const TITLE_LAYOUT = {
  left: 60.5,
  top: 29,
  width: 485,
  height: 56,
} as const;

/** Desc SVG tight crop (420×36) → relative to plate. */
const DESC_LAYOUT = {
  left: 184.5,
  top: 101,
  width: 420,
  height: 36,
} as const;

/**
 * Level description card (Figma plate_courier_license / l_1 162:24012) —
 * HTML plate + stroked SVG texts + star icon.
 * Card: Left 110.36, 859×179.85.
 */
export function LevelCard({
  top,
  title,
  description,
  achieved = false,
  isCurrent = false,
}: LevelCardProps) {
  const className = [
    'level-card',
    isCurrent ? 'level-card--current' : achieved ? 'level-card--achieved' : 'level-card--locked',
  ].join(' ');

  return (
    <div
      className={className}
      style={{ top }}
      aria-label={title}
      aria-current={isCurrent ? 'true' : undefined}
    >
      <div className="level-card__plate" aria-hidden />
      <svg
        className="level-card__title"
        width={TITLE_LAYOUT.width}
        height={TITLE_LAYOUT.height}
        viewBox={`0 0 ${TITLE_LAYOUT.width} ${TITLE_LAYOUT.height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        style={TITLE_LAYOUT}
      >
        <text
          className="level-card__title-text"
          textAnchor="start"
          xmlSpace="preserve"
        >
          <tspan x={0} y={42}>
            {title}
          </tspan>
        </text>
      </svg>
      <img
        className="level-card__star"
        src={starImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <svg
        className="level-card__desc"
        width={DESC_LAYOUT.width}
        height={DESC_LAYOUT.height}
        viewBox={`0 0 ${DESC_LAYOUT.width} ${DESC_LAYOUT.height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        style={DESC_LAYOUT}
      >
        <text
          className="level-card__desc-text"
          textAnchor="start"
          xmlSpace="preserve"
        >
          <tspan x={-2.4} y={28.1004}>
            {description}
          </tspan>
        </text>
      </svg>
    </div>
  );
}
